import { useQuery } from 'data-fetching-client';
import { FETCH_WORKFLOWS } from 'email-management-lib/EmailArchiveOrDelete/queries/workflows';
import { useMemo } from 'react';
function useWorkflows({
  emails
}) {
  const {
    data,
    loading
  } = useQuery(FETCH_WORKFLOWS, {
    variables: {
      emails
    }
  });
  const emailsWithWFInfo = useMemo(() => {
    if (!data) {
      return [];
    }
    return [...data.emailsWithWorkflows].sort((a, b) => {
      if (a.flows.length && b.flows.length) {
        return b.emailUpdatedAt - a.emailUpdatedAt; // if they both have active workflows, sort by updated date
      } else {
        return a.flows.length ? -1 : 1; // render emails with active workflows first
      }
    });
  }, [data]);
  return useMemo(() => ({
    loading,
    emailsWithWFInfo
  }), [emailsWithWFInfo, loading]);
}
export default useWorkflows;